// HTTP client for /api/customers. Mirrors src/lib/fs/customers.ts signatures.
import type { Customer } from "../customers/types";
import { api } from "./_client";

// Row shape from the API (matches core.customers)
interface CustomerRow {
  id: string;
  name: string;
  website: string | null;
  contact_name: string | null;
  contact_email: string | null;
  contact_phone: string | null;
  account_manager: string | null;
  sales_manager: string | null;
  relationships_manager: string | null;
  created_at: string;
  updated_at: string;
}

function rowToCustomer(row: CustomerRow): Customer {
  return {
    id: row.id,
    name: row.name,
    website: row.website ?? "",
    contact_name: row.contact_name ?? "",
    contact_email: row.contact_email ?? "",
    contact_phone: row.contact_phone ?? "",
    account_manager_folder: row.account_manager ?? "",
    sales_manager_folder: row.sales_manager ?? "",
    relationships_manager_folder: row.relationships_manager ?? "",
    created_at: row.created_at,
    updated_at: row.updated_at,
  };
}

function customerToRow(c: Customer): Partial<CustomerRow> {
  return {
    id: c.id || undefined,
    name: c.name,
    website: c.website || null,
    contact_name: c.contact_name || null,
    contact_email: c.contact_email || null,
    contact_phone: c.contact_phone || null,
    account_manager: c.account_manager_folder || null,
    sales_manager: c.sales_manager_folder || null,
    relationships_manager: c.relationships_manager_folder || null,
  };
}

export async function readCustomers(_repoPath?: string): Promise<Customer[]> {
  const rows = await api<CustomerRow[]>("GET", "/api/customers");
  return rows.map(rowToCustomer);
}

export async function saveCustomers(
  _repoPath: string,
  customers: Customer[],
): Promise<void> {
  await api<CustomerRow[]>("PUT", "/api/customers", customers.map(customerToRow));
}
